const ONE_MINUTE_IN_SECONDS = 60;
export const ONE_HOUR_IN_SECONDS = 60 * ONE_MINUTE_IN_SECONDS;

const ONE_SECOND_IN_MS = 1000;
export const FIVE_SECONDS_IN_MS = 5 * ONE_SECOND_IN_MS;
export const ONE_MINUTE_IN_MS = ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MS;
export const FIVE_MINUTES_IN_MS = 5 * ONE_MINUTE_IN_MS;
export const TEN_MINUTES_IN_MS = 10 * ONE_MINUTE_IN_MS;
export const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;

export const API_MAX_PAGE_LIMIT = 50;

// The bulk-fetch endpoints accept up to 100 ids per request.
export const BULK_FETCH_MAX_ITEMS = 100;

// Shared between loop-intelligence and org-intelligence so the loop-scoped and org-scoped
// Loop Intelligence surfaces can never drift apart independently.
export const LOOP_INTELLIGENCE_CONTENT_MAX_WIDTH_CLASS = 'max-w-[1120px]';
